import { Component, OnInit } from '@angular/core';
import { KycService } from '@app/core/kyc.service';
import { routerTransition } from '../../router.animations';

import { QuestionControlService } from '@app/core/question-control.service';
import { QuestionService } from '@app/core/question.service';
import { renderFinancialData } from '@app/features/my-financial/my-financial';
import * as MyFinancialsConstants from '@app/features/my-financial/constants';
import { Router } from '@angular/router';
import { NavTabService } from '@app/core/navTab.service';
import { onFinancialError } from '@app/core/selectors';
import * as _ from 'lodash';
import * as moment from 'moment';

@Component({
  selector: 'app-my-financial',
  templateUrl: './my-financial.component.html',
  animations: [routerTransition()],
  host: { '[@routerTransition]': '' }
})
export class MyFinancialComponent implements OnInit {
  financialData: any;
  choosenFinancial: any;
  selectedModal = '';
  showModal = false;
  amountOfRegularSavings: number;
  age: number;
  isSlider: boolean;
  isError: boolean = true;
  constructor(
    private kycService: KycService,
    private questionService: QuestionService,
    private qcs: QuestionControlService,
    private router: Router,
    private navTabService: NavTabService
  ) {}

  ngOnInit() {
    const { userProfile } = this.kycService.kyc.profile;
    this.isSlider =
      (Number(userProfile.marital) === 1 ||
        String(userProfile.marital) === '') &&
      (userProfile.kids === null || userProfile.kids === 0)
        ? true
        : false;
    this.age = userProfile.age;
    const { financial } = this.kycService.kyc.financial;
    _.forEach(financial, item => {
      if (item.key === 'savings') {
        _.forEach(item.questionRaws, item => {
          if (item.key === 'yearRetirement' && item.value === 60) {
            item.options.range.min = this.age;
            item.value = this.age;
          }
          if (this.isSlider) {
            if (item.key === 'yearNotNeedSupport' && item.value === 25) {
              item.value = this.age + 2;
              item.options.range.min = this.age + 2;
            } else if (
              item.key === 'myFamilyMonthlyExpenses' &&
              item.value === 0
            ) {
              item.value = 100;
            }
          } else {
            if (item.key === 'yearNotNeedSupport' && item.value === 25) {
              item.value = this.age;
              item.options.range.min = this.age;
            } else if (
              item.key === 'myFamilyMonthlyExpenses' &&
              item.value === 0
            ) {
              item.value = 0;
            }
          }
        });
      }
    });
    this.financialData = this.getData('savings', financial);
  }

  getData(key: string, arr: any) {
    let data: any;
    _.forEach(arr, financial => {
      if (financial.key === key) {
        this.choosenFinancial = financial;
        this.choosenFinancial.iconColor = MyFinancialsConstants.ICON_BLUE;
      }
    });
    data = renderFinancialData(
      this.choosenFinancial.questionRaws,
      this.questionService,
      this.qcs
    );
    return data;
  }

  goToNextPage() {
    this.kycService.kyc.financial.financial.forEach(financial => {
      if (financial.key === this.choosenFinancial.key) {
        if (!financial.displayData) {
          financial.displayData = true;
        }
        financial.questionRaws.forEach(question => {
          question.value = Number(this.financialData.form.value[question.key]);
        });
      }
    });
    this.isError = onFinancialError(
      this.kycService.kyc.financial.financial[0].questionRaws,
      this.age
    );
    if (this.isError) {
      this.kycService.kyc.financial.completed = true;
      let tenant = this.kycService.getTenant();
      this.router.navigateByUrl(tenant + '/journey/my-lifestyle');
      this.navTabService.setActiveTab('lifestyle');
      const smokedValue =
        Number(this.kycService.kyc.profile.userProfile.smoked) === 1 ? 100 : 0;
      _.map(this.kycService.kyc.lifestyle.lifestyle[0].questionRaws, item => {
        if (item.key === 'iSmoke') item.value = smokedValue;
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/features/my-financial/my-financial.component.ts